import { defineFeature } from "../../app/feature";
import { QualityDashboardPage } from "./QualityDashboardPage";

/** Quality and performance of the proof runs (task 4150.7; DESIGN-SPEC 31.4, 32.2). Reads the report
 * scripts/proof/quality_report.py writes. Owned by the proof lane. */
export default defineFeature({
  id: "quality-dashboard",
  title: "Quality dashboard",
  routes: [{ path: "/quality-dashboard", Component: QualityDashboardPage }],
  nav: { label: "Quality", path: "/quality-dashboard", section: "Corpus Runs", order: 40 },
  permissions: ["engagement.read"],
});
